import dayjs from "dayjs";

/**
 * 抄表结算-数据/日期处理公共工具。
 * 原先在 runxingtai / jingxi / jingxiCommon / haisida 四个模板中逐字重复,现统一到此。
 */

/**
 * 由 "YYYY-MM" 月份字符串,计算当月首末日(YYYY-MM-DD)。
 * @param {string} timer 形如 "2026-07"
 * @returns {{ firstDay: string, lastDay: string }}
 */
export function getMonthRange(timer) {
  const [year, month] = timer.split("-");
  const firstDayOfMonth = dayjs(`${year}-${month}-01`);
  const lastDayOfMonth = firstDayOfMonth.add(1, "month").subtract(1, "day");
  return {
    firstDay: firstDayOfMonth.format("YYYY-MM-DD"),
    lastDay: lastDayOfMonth.format("YYYY-MM-DD")
  };
}

/**
 * 月份选择器的禁选范围:未来不可选,且只能选最近约半年。
 * (等价于原 disabledDatedisabledDate)
 */
export function disabledHalfYear(date) {
  const latestHalfYear = dayjs().subtract(7, "month");
  return dayjs(date) >= dayjs() || dayjs(date) <= latestHalfYear;
}

/**
 * 对后端返回的 overview 做二次加工(百分比、甲乙方金额、储能电价等)。
 * 保持与原模板逐字一致的口径。会就地修改并返回入参。
 * @param {object} overview totalAllData.overview
 */
export function normalizeOverview(overview) {
  if (!overview) return overview;
  overview.loss = (overview.loss * 100).toFixed(2) + "%";
  overview.ratioValueA = (overview.ratio1 * 100).toFixed(2) + "%";
  overview.ratioValueB = (overview.ratio2 * 100).toFixed(2) + "%";
  overview.divideInto = "比例";

  overview.moneyA = (overview.actuallyIncome * overview.ratio1).toFixed(2);
  overview.moneyB = (overview.actuallyIncome * overview.ratio2).toFixed(2);

  overview.esPriceLoss = overview.esPrice.toFixed(2);
  overview.esPower = overview.savings == null ? 0 : overview.savings;
  overview.esPowerA = overview.chargePower == null ? "--" : overview.chargePower;
  return overview;
}
